import { ReactNode } from "react";
import { Link, NativeLink, DisabledLink } from "./styles";
import Loader from "../Loader";

const sizeMap = {
  xs: "small",
  sm: "small",
  md: "medium",
  lg: "large",
  xl: "large",
};

const typeMap = {
  filled: "primary",
  outline: "secondary",
  link: "link",
};

const skinMap = {
  purple: "default",
  transparent: "transparent",
  lightBlue: "default",
  lightGray: "inverse",
  white: "default",
  "white-black": "inverse",
  lightGreen: "default",
};

interface LinkProps {
  href: string;
  style?: any;
  options: {
    type: "filled" | "outline" | "link";
    size: "xs" | "sm" | "md" | "lg" | "xl";
    skin: "purple" | "transparent" | "lightBlue" | "lightGray" | "white" | "black" | "white-black" | "lightGreen";
    block?: boolean;
    native?: boolean;
  };
  target?: string;
  children: string | ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  noFollow?: boolean;
}

const Component = ({
  href,
  disabled,
  loading,
  target,
  options,
  children,
  ...rest
}: LinkProps) => {
  const { native = true, block, type, size, skin } = options;

  if (disabled) {
    return (
      <DisabledLink
        {...options}
        {...rest}
        block={block}
        size={size}
        type={type}
        skin={skin}
      >
        {loading ? <Loader /> : children}
      </DisabledLink>
    );
  }

  if (native) {
    return (
      <NativeLink
        to={href}
        {...rest}
        target={target}
        block={block}
        size={size}
        type={type}
        skin={skin}
      >
        {children}
      </NativeLink>
    );
  }

  return (
    <Link
      href={href}
      {...rest}
      target={target}
      block={block}
      size={size}
      type={type}
      skin={skin}
    >
      {children}
    </Link>
  );
};

export default Component;
